import { graphql, useStaticQuery } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import ActivityExample from "../shared/program/ActivityExample"
import HeadingM from "../shared/HeadingM"

const query = graphql`
  query {
    independent: file(relativePath: { eq: "sutea/activity/independent.jpg" }) {
      childImageSharp {
        gatsbyImageData(width: 500, height: 500)
      }
    }
    rhythm_music: file(relativePath: { eq: "sutea/activity/rhythm_music.png" }) {
      childImageSharp {
        gatsbyImageData(width: 500, height: 500)
      }
    }
    seasonal_events: file(relativePath: { eq: "sutea/activity/seasonal_events.png" }) {
      childImageSharp {
        gatsbyImageData(width: 500, height: 500)
      }
    }
  }
`

const ProgramActivityExample = () => {
  const data = useStaticQuery(query)
  const items = [
    {
      title: "自主活動",
      description:
        "進行、記録等の役割分担し、子どもたち主体で会議をする機会を頻繁に設けています。自分達で決めたことを活動や環境に反映させることで自主的に伝えることの大切さ、達成感を味わってもらえるよう工夫しています。",
      image: getImage(data.independent),
    },
    {
      title: "リズム、音楽活動",
      description:
        "好きな曲に合わせて身体を動かしたり、楽器、音楽教材等を使い楽しみながらリズム感を身に付ける活動を行っています。集団で過ごすことが苦手な子でも音楽を通して自然に楽しめる活動を日々考えています。",
      image: getImage(data.rhythm_music),
    },
    {
      title: "外出活動、季節イベント",
      description:
        "季節に合わせたイベントを、準備も合わせて子どもたちに積極的に参加していただき、その時期ならではの楽しみ方を皆で共有する時間を大切にしています。",
      image: getImage(data.seasonal_events),
    },
  ]
  return (
    <div>
      <HeadingM title="活動事例" target="sutea" />
      <ActivityExample items={items} />
    </div>
  )
}

export default ProgramActivityExample
